export function fixUrl(url) {
  return String(url).replace(
    "fabriccamultimidia.com.br",
    "fabriccamultimidia.com"
  );
}
